import {
  BaseQueryDetailsFragment,
  ProjectFieldsFragment,
  ProjectStakeholder,
  StakeholderRole,
  TranslationType
} from 'generated/graphql';
import { formatUserName } from './formatUserName';

export const getStakeholderWithRole = (
  project: ProjectFieldsFragment,
  role: StakeholderRole
): ProjectStakeholder | undefined => {
  if (!project.stakeholders) return undefined;

  const stakeholder = project.stakeholders.find(
    (stakeholder) => stakeholder?.stakeholderRole === role
  );

  return stakeholder || undefined;
};

export const getSubstituteProjectManager = (project?: ProjectFieldsFragment) => {
  return getStakeholderFormattedName(StakeholderRole.SUBSTITUTE_PROJECT_MANAGER, project);
};

export const getQualityExpert = (project?: ProjectFieldsFragment) => {
  return getStakeholderFormattedName(
    StakeholderRole.QUALITY_EXPERT,
    project,
    project?.qualityExpert || ''
  );
};

export const getProjectManager = (project?: ProjectFieldsFragment) => {
  return getStakeholderFormattedName(
    StakeholderRole.PROJECT_MANAGER,
    project,
    project?.projectManager || ''
  );
};

const getStakeholderFormattedName = (
  role: StakeholderRole,
  project?: ProjectFieldsFragment,
  defaultValue?: string
): string => {
  if (!project) return '';

  const stakeholder = getStakeholderWithRole(project, role);

  if (!stakeholder) {
    return defaultValue || '';
  }

  return formatUserName({
    userName: stakeholder.displayName || undefined,
    sapNumber: stakeholder.userName
  });
};

export const getQueryResponsible = (query?: BaseQueryDetailsFragment) => {
  const isMarketingQuery = query?.translationType === TranslationType.MARKETING;

  return isMarketingQuery
    ? getStakeholderFormattedName(StakeholderRole.REQUESTER, query.project)
    : getStakeholderFormattedName(
        StakeholderRole.QUERY_TRACKER_CONTACT,
        query?.project,
        query?.project?.queryResponsible || ''
      );
};
